import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import { InputAdornment, Stack } from '@mui/material'
import { TextField } from '@ui/forms'
import {
  CheckSettingsFormFieldsCommonProps,
  compactCheckSettingsFormSx,
  getCheckSettingsStackSpacing,
} from '../checkSettingsFormFieldLayout'
import { DefaultValues } from '../types'

const MEMBER_SETTINGS_ROOT = 'memberCheckSettingsSelectedElement' as const

interface Props extends CheckSettingsFormFieldsCommonProps {
  memberCheckSettingsSelectedPath?: string
}

const VibrationCheckSettingsFormFields = ({
  disabled,
  compact,
  memberCheckSettingsSelectedPath = MEMBER_SETTINGS_ROOT,
}: Props): ReactElement | null => {
  const memberCheckSettingsSelectedElement: SettingsOnMember = useWatch<DefaultValues>({
    name: memberCheckSettingsSelectedPath as 'memberCheckSettingsSelectedElement',
  })

  if (!('vibration_check_settings' in memberCheckSettingsSelectedElement))
    throw new Error('Vibration check settings not available')

  return (
    <Stack
      direction="column"
      spacing={getCheckSettingsStackSpacing(compact, 2)}
      maxWidth={120}
      sx={compact ? compactCheckSettingsFormSx : undefined}
    >
      <TextField
        name={`${memberCheckSettingsSelectedPath}.vibration_check_settings.slab_width`}
        label="Deckenbreite"
        type="number"
        disabled={disabled}
        InputProps={{
          endAdornment: <InputAdornment position="end">m</InputAdornment>,
        }}
        data-cy="txt-vibration-checks-slab-width"
      />
    </Stack>
  )
}

export default VibrationCheckSettingsFormFields
